var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{staticClass:"buy-me-claim",attrs:{"title":"","active":_vm.popupActive},on:{"update:active":function($event){_vm.popupActive=$event}}},[_c('BuyMeClaim')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }